import { baseApi } from "../redux/baseAPI";
import { parseResponse } from "../utils/common_lib";

export const locationsApi = baseApi.injectEndpoints({
  tagTypes: ["Locations", "NursingChatHome", "Users"],
  endpoints: (builder) => ({
    getStates: builder.query({
      query: (params) => ({
        url: `/utilities/get_states.json`,
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    getPlacesofService: builder.query({
      query: (params) => ({
        url: `/utilities/listing/pos_code.json`,
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    getPracticeFlyer: builder.query({
      query: (params) => ({
        url: `/practices/get_practice_flyer.json`,
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    getProviders: builder.query({
      query: (params) => ({
        url: `/providers.json`,
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    getLocations: builder.query({
      query: (params) => ({
        url: `/practices/locations.json`,
        method: "GET",
        params: params,
      }),
      providesTags: ["Locations"],
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    getNurseLocations: builder.query({
      query: (params) => ({
        url: `/nursing_home_management/get_nurse_locations.json`,
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    getNursingHomeChat: builder.query({
      query: (params) => ({
        url: `/nursing_home/index.json`,
        method: "GET",
        params: params,
      }),
      providesTags: ["NursingChatHome"],
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    getNursingHomeUsers: builder.query({
      query: (params) => ({
        url: `/nursing_home/list_users.json`,
        method: "GET",
        params: params,
      }),
      providesTags: ["Users"],
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    getNursingHomeOwner: builder.query({
      query: (params) => ({
        url: `/nursing_home/get_owner.json`,
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    disableNursingHome: builder.query({
      query: (params) => ({
        url: `/nursing_home/disable_nursing_chat.json`,
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    enableNursingHome: builder.query({
      query: (params) => ({
        url: `/nursing_home/enable_nursing_chat.json`,
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    setNursingHomeOwner: builder.mutation({
      query: (formData) => {
        return {
          url: `/nursing_home/set_owner.json`,
          method: "POST",
          data: formData,
          body: formData,
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    addNurse: builder.mutation({
      query: (formData) => {
        return {
          url: `/nursing_home_management/add_nurse.json`,
          method: "POST",
          params: formData.params,
          data: formData.body,
          body: formData.body,
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    updateNurse: builder.mutation({
      query: (formData) => {
        return {
          url: `/nursing_home_management/edit_nurse.json`,
          method: "POST",
          params: formData.params,
          data: formData.body,
          body: formData.body,
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    markUnMarkNurseAdmin: builder.mutation({
      query: (data) => {
        return {
          url: `/nursing_home_management/add_nurse_as_facility_admin.json`,
          method: "POST",
          data
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    checkInCheckOutNurse: builder.mutation({
      query: (data) => {
        return {
          url: `/nursing_home_management/sync_check_in_out_nurse.json`,
          method: "POST",
          data
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    addUser: builder.mutation({
      query: (formData) => {
        return {
          url: `/nursing_home/add_user.json`,
          method: "POST",
          params: formData.params,
          data: formData.body,
          body: formData.body,
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    createLocation: builder.mutation({
      query: (formData) => {
        return {
          url: `/practices/create_location.json`,
          method: "POST",
          data: formData,
          body: formData,
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    deleteNursingHome: builder.mutation({
      query: (formData) => {
        return {
          url: `/nursing_home_management/remove_nurse_from_location.json`,
          method: "POST",
          params: formData.params,
          data: formData.body,
          body: formData.body,
        };
      },
      // invalidatesTags: ["NursingChatHome"],
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    deleteUser: builder.mutation({
      query: (formData) => {
        return {
          url: `/nursing_home/remove_user.json`,
          method: "POST",
          params: formData.params,
          data: formData.body,
          body: formData.body,
        };
      },
      // invalidatesTags: ["Users"],
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    updateLocation: builder.mutation({
      query: (formData) => {
        return {
          url: `/practices/update_location_status.json`,
          method: "POST",
          params: formData.params,
          data: formData.body,
          body: formData.body,
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    fetchCommucationSettings: builder.query({
      query: (params) => ({
        url: `/communication_settings.json`,
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    deleteCommunicationSettings: builder.mutation({
      query: (formData) => {
        return {
          url: `/communication_settings/deleteSetting.json`,
          method: "POST",
          params: formData.params,
          data: formData.body,
          body: formData.body,
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    saveCommunicationSettings: builder.mutation({
      query: (formData) => {
        return {
          url: `/communication_settings/save.json`,
          method: "POST",
          params: formData.params,
          data: formData.body,
          body: formData.body,
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    getNurses: builder.query({
      query: (params) => ({
        url: `/nursing_home_management/nurses.json`,
        method: "GET",
        params: params,
      }),
      providesTags: ["NurseListing"],
      transformResponse: (response, meta, arg) => {
        return response?.response
      },
    }),
    addNurseToLocation: builder.mutation({
      query: (formData) => {
        return {
          url: `/nursing_home_management/add_nurse_to_location.json`,
          method: "POST",
          params: formData.params,
          data: formData.body,
          body: formData.body,
        };
      },
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
    deleteNurse: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_management/delete_nurse.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetStatesQuery,
  useGetPlacesofServiceQuery,
  useGetPracticeFlyerQuery,
  useGetProvidersQuery,
  useGetLocationsQuery,
  useGetNurseLocationsQuery,
  useGetNursingHomeChatQuery,
  useGetNursingHomeUsersQuery,
  useGetNursingHomeOwnerQuery,
  useGetDisableNursingHomeQuery,
  useGetEnableNursingHomeQuery,
  useSetNursingHomeOwnerMutation,
  useAddNurseMutation,
  useAddUserMutation,
  useUpdateNurseMutation,
  useMarkUnMarkNurseAdminMutation,
  useCheckInCheckOutNurseMutation,
  useCreateLocationMutation,
  useDeleteNursingHomeMutation,
  useDeleteUserMutation,
  useUpdateLocationMutation,
  useFetchCommucationSettingsQuery,
  useDeleteCommunicationSettingsMutation,
  useSaveCommunicationSettingsMutation,
  useGetNursesQuery,
  useAddNurseToLocationMutation,
  useDeleteNurseMutation,
} = locationsApi;
